// extracted by mini-css-extract-plugin
export default {"main":"LegalPageLayout_main__8B-xs","pageHeader":"LegalPageLayout_pageHeader__dCAER","meta":"LegalPageLayout_meta__iwDHY","content":"LegalPageLayout_content__gMqxy"};